import { browser } from '$app/environment';

export default {
  setup: async (node) => {
    if (browser) {
      const { Dropdown } = await import('bootstrap');
      new Dropdown(node);
    }
    return {};
  },
};
